<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}

.el-tooltip__popper{
  max-width: 50%;
}

/* 蓝色复制成功提示样式 */
.copy-success-blue .el-message__content {
  color: #409EFF !important;
}

.copy-success-blue .el-message__icon {
  color: #409EFF !important;
}

/* 橙色复制成功提示样式 */
.copy-success-orange .el-message__content {
  color: #E6A23C !important;
}

.copy-success-orange .el-message__icon {
  color: #E6A23C !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue